import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconControllerButtonTriangle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="controller-button-triangle, menu, options, action, more, expand"><circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/><path d="M12.0003 7.75L16.364 14.875H7.63672L12.0003 7.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconControllerButtonTriangle;
